import React from 'react';

const FounderBadge = ({ isFounder }) => {
  if (!isFounder) return null;

  return (
    <span style={{
      padding: '6px 10px',
      borderRadius: '6px',
      fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
      fontSize: '12px',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: '#dc1d08', // Signature red
      color: '#ffffff', // White lettering
      border: '1.5px solid #dc1d08'
    }}>
      Founder
    </span>
  );
};

export default FounderBadge;




